var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20.188,
    viewBox: "0 0 17 20.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-download",
    d: "M7.063,21.063H21.938a1.063,1.063,0,0,1,0,2.125H7.063a1.063,1.063,0,0,1,0-2.125Zm8.5-6.189,3.445-3.445,1.5,1.5L14.5,18.942,8.489,12.931l1.5-1.5,3.446,3.445V3h2.125V14.874Z",
    transform: "translate(-6 -3)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.02d62195f45bec94a503a516b00c4969.svg";
export { ForwardRef as ReactComponent };